<template>
  <div class="address">
    <div class="address_box">
      <p>艾禹护护理站</p>
      <div class="address_">
        <div>
          <img src="../assets/images/branch1.png" class="img1" />
          <span>地址:上海市浦东新区张杨路2590号</span>
        </div>
        <div>
          <img class="img2" src="../assets/images/branch2.png" />
          <span>电话:5065-6698</span>
        </div>
      </div>
    </div>
    <div class="address_box">
      <p>德心居护理站</p>
      <div class="address_">
        <div>
          <img src="../assets/images/branch1.png" class="img1" />
          <span>地址:上海市浦东新区东三里桥路237-2号</span>
        </div>
        <div>
          <img class="img2" src="../assets/images/branch2.png" />
          <span>电话:5858-1170</span>
        </div>
      </div>
    </div>

    <div class="address_box">
      <p>艾悦护护理站</p>
      <div class="address_">
        <div>
          <img src="../assets/images/branch1.png" class="img1" />
          <span>地址:上海市浦东新区海阳路452号</span>
        </div>
        <div>
          <img class="img2" src="../assets/images/branch2.png" />
          <span>电话:5089-8978</span>
        </div>
      </div>
    </div>
    <div class="address_box">
      <p>艾高护护理站</p>
      <div class="address_">
        <div>
          <img src="../assets/images/branch1.png" class="img1" />
          <span>地址:上海市浦东新区和龙路447-3号</span>
        </div>
        <div>
          <img class="img2" src="../assets/images/branch2.png" />
          <span>电话:5890-9055</span>
        </div>
      </div>
    </div>
    <div class="address_box">
      <p>爱介护沪东为老服务中心</p>
      <div class="address_">
        <div>
          <img src="../assets/images/branch1.png" class="img1" />
          <span>地址:上海市浦东新区五莲路430号</span>
        </div>
        <div>
          <img class="img2" src="../assets/images/branch2.png" />
          <span>电话:5065-6698</span>
        </div>
      </div>
    </div>
    <div class="address_box">
      <p>爱介护北蔡为老服务中心</p>
      <div class="address_">
        <div>
          <img src="../assets/images/branch1.png" class="img1" />
          <span>地址:上海市浦东新区锦尊路229号</span>
        </div>
        <div>
          <img class="img2" src="../assets/images/branch2.png" />
          <span>电话:5858-1170</span>
        </div>
      </div>
    </div>
    <div class="address_box">
      <p>总部</p>
      <div class="address_">
        <div>
          <img src="../assets/images/branch1.png" class="img1" />
          <span>地址:上海市浦东新区崮山路968号</span>
        </div>
        <div class="add_right">
          <img class="img2" src="../assets/images/branch2.png" />
          <span>电话:5888-6722</span>
        </div>
      </div>
    </div>
    <div class="address_box">
      <P>上海爱博智护数字科技有限公司</P>
    </div>
    <div class="address_box">
      <P>上海艾博智护数字科技有限公司</P>
    </div>
    <div class="address_box">
      <P>上海迪季人力资源有限公司</P>
    </div>
    <div class="address_box">
      <P>上海浦东迪吉健康职业技能培训中心</P>
    </div>
    <div class="address_box">
      <P>爱介护盖文（上海）建筑工程有限公司</P>
    </div>
    <div class="address_box">
      <P>上海爱乐护养老服务有限公司</P>
    </div>
    <div class="address_box">
      <P>爱介护怡欣居家养老服务中心</P>
    </div>
    <div class="address_box">
      <P>沈阳爱介护社区养老服务有限公司</P>
    </div>
    <div class="address_box">
      <P>抚顺爱介护社区养老服务有限公司</P>
    </div>
    <div class="address_box">
      <P>爱介护（吉林）居家养老有限公司</P>
    </div>
    <div class="address_box">
      <P>北京爱介护健康科技有限公司</P>
    </div>
    <div class="address_box">
      <P>北京爱介护健康科技有限公司朝阳护理站</P>
    </div>
    <div class="address_box">
      <P>济南善佳爱介护养老服务有限公司</P>
    </div>
    <div class="address_box">
      <P>南京爱介护养老服务有限公司</P>
    </div>
    <div class="address_box">
      <P>南京江宁宁帛护理服务有限公司</P>
    </div>
    <div class="address_box">
      <P>爱介护昆明护理服务有限公司</P>
    </div>
    <div class="address_box">
      <P>爱介护（辽宁）居家养老科技服务有限公司</P>
    </div>
    <div class="address_box">
      <P>爱介护酒泉居家养老服务有限公司</P>
    </div>
    <div class="address_box">
      <P>金华爱介护护理服务有限公司</P>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
};
</script>

<style scoped>
.address {
  color: #fff;
  height: 360px;
  overflow: hidden;
  overflow-y: scroll;
  text-align: left;
  margin-left: 50px;
  margin-top: 50px;
  line-height: 40px;
  width: 690px;
}
.address p {
  font-size: 24px;
  padding-top: 10px;
}
.address_ {
  display: flex;
  justify-content: space-between;
  padding-right: 60px;
}
.address_ div {
  margin-top: 8px;
  /* border-bottom: 1px solid #fff; */
}

.address_ div:nth-child(1) img {
  width: 17px;
  height: 22px;
  vertical-align: sub;
}
.address_ div:nth-child(2) img {
  width: 24px;
  height: 21px;
}
.address span {
  font-size: 18px;
  margin-right: 40px;
}
.address::-webkit-scrollbar {
  width: 16px;
  height: 1px;
}
.address::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(86, 86, 86, 0.2);
  background: #fff;
}
.address::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0px 5px rgba(202, 202, 202, 0.2);
  border-radius: 10px;
  background: #cccccc;
}
</style>


// WEBPACK FOOTER //
// src/components/Address.vue